import {RichText} from 'exceljs';

export const getRichTextLength = (richText: RichText[]) => {
    return richText.reduce((acc, currentRichText) => acc + currentRichText.text.length, 0);
};
